module.exports = __webpack_public_path__ + "img/world-wine-regions.c69d9d5a.png";